module.exports = __webpack_public_path__ + "img/image-banner01.0e039842.png";